import axios from './axios';

export const rolesAPI = {
  // ── Roles ──────────────────────────────────────────────────────────────────

  getAll: async () => {
    const response = await axios.get('/roles');
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/roles/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/roles', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`/roles/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/roles/${id}`);
    return response.data;
  },

  // ── Users ──────────────────────────────────────────────────────────────────

  getAllUsers: async () => {
    const response = await axios.get('/roles/users/all');
    return response.data;
  },

  updateUserRole: async (userId, role) => {
    const response = await axios.patch(`/roles/users/${userId}/role`, { role });
    return response.data;
  },

  // ── Employee account management ────────────────────────────────────────────

  /**
   * Create a new employee account.
   * POST /api/v1/roles/users
   * Body: { name, email, phone, password, role, isActive }
   */
  createEmployee: async (data) => {
    const response = await axios.post('/roles/users', data);
    return response.data;
  },

  /**
   * Update an employee's details (name, email, phone, role, isActive, password?).
   * PUT /api/v1/roles/users/:userId
   * Body: { name?, email?, phone?, role?, isActive?, password? }
   */
  updateEmployee: async (userId, data) => {
    const response = await axios.put(`/roles/users/${userId}`, data);
    return response.data;
  },
};
